<div class="panel-body ">
  <div class="col-sm-12 panel panel-default panel-margin-bottom panel-margin-top">
    <div class="panel-body">
      <div class="row row-eq-height">
        <div class="col-md-4 panel panel-default ">
          <div id="licensee-name" class="panel-title ">
            <span class="field-code ">V614</span>
            <b>Licensee Name</b>
          </div>
          <div class="panel-body " id="bondsmanDetails-information-nameAddress">
            <div class="table-responsive scroll-hide-xy">
              <table class="full-width table-nowrap">
                <tr>
                  <td class="text-align-left">
                    <span class="field-code">V611 </span>
                    <div *ngIf="bondsman.isLicenseeThisType(bondsman.SURETY_INSURANCE_COMPANY) === false">
                      <div *ngIf="bondsman.getLicenseeMiddleName() !== ''">
                        <span title="{{bondsman.getLicenseeLastName}}"> {{bondsman.getLicenseeLastName()}}, {{bondsman.getLicenseeFirstName()}}, {{bondsman.getLicenseeMiddleName()}}</span>
                      </div>
                      <div *ngIf="bondsman.getLicenseeMiddleName() === ''">
                        <span title="{{bondsman.getLicenseeLastName}}"> {{bondsman.getLicenseeLastName()}}, {{bondsman.getLicenseeFirstName()}}</span>
                      </div> 
                    </div>  
                    <div *ngIf="bondsman.isLicenseeThisType(bondsman.SURETY_INSURANCE_COMPANY) === true">
                        <span title="{{bondsman.getBusinessName()}}"> {{bondsman.getBusinessName()}}</span>
                    </div>                 
                  </td>
                </tr>
                <tr *ngIf="bondsman.getLicenseeAddressLine1()">
                  <td class="text-align-left">
                    <span class="field-code">V614 </span>
                    <span title="{{bondsman.getLicenseeAddressLine1()}}">{{bondsman.getLicenseeAddressLine1()}}</span>
                  </td>
                </tr>
                <tr *ngIf="bondsman.getLicenseeAddressLine2()">
                  <td class="text-align-left">
                    <span class="field-code">V616 </span>
                    <span title="{{bondsman.getLicenseeAddressLine2()}}">{{bondsman.getLicenseeAddressLine2()}}</span>
                  </td>
                </tr>
                <tr>
                  <td class="text-align-left">
                    <span class="field-code">V618 </span>
                    <span title="{{bondsman.getLicenseeCityName()}}">{{bondsman.getLicenseeCityName()}}</span><span class="field-code">V619 </span><span title="{{bondsman. getLicenseeStateAbbreviation()}}">{{bondsman. getLicenseeStateAbbreviation()}}</span>
                    <span class="field-code">V620 </span>
                    <span title="{{bondsman.getLicenseeAddressesZipCode()}}">{{bondsman.getLicenseeAddressesZipCode()}}</span>
                  </td>
                </tr>
                <tr *ngIf="bondsman.getLicenseeCounty() !== '' && bondsman.getLicenseeCounty() !== 'ALL'">
                  <td class="text-align-left">
                    <span class="field-code">V615 </span>
                    <span title="{{bondsman.getLicenseeCounty()}}">{{bondsman.getLicenseeCountyFormatted()}}</span>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
        <div class="col-md-4 panel panel-default ">
          <div class="panel-title ">
            <span class="field-code ">V603</span>
            <b>Department of Insurance License Number</b>
          </div>
          <div class="panel-body " id="bondsmanDetails-information-prohibit-reason">
            {{bondsman.getLicenseNumber()}}
          </div>
        </div>
        <div *ngIf="bondsman.getLicenseTypeList().length !== 0" class="col-md-4 panel panel-default ">
          <div class="panel-title ">
            <span class="field-code ">V637</span>
            <b>License Type(s)</b>
          </div>
          <div class="panel-body ">
            <ul>
              <li *ngFor="let licenseType of bondsman.getLicenseTypeList(); let i = index;" id="{{'bondsmanDetails-information-licenseType-' + i}}">
                {{bondsman.getLicenseTypeName(licenseType)}}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/bondsman/licensee-information/licensee-information.component.html